import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'

export default function SaveCancelButtons({
  isSubmitting,
  handleReset,
  handleSubmit,
  newProfile,
}) {
  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        type="submit"
        className="save"
        disabled={isSubmitting}
        onClick={handleSubmit}
      >
        {newProfile ? 'Create' : 'Save'} Profile
      </Button>
      <Button
        variant="outlined"
        color="primary"
        size="large"
        type="button"
        onClick={handleReset}
      >
        Cancel
      </Button>
    </>
  )
}

SaveCancelButtons.propTypes = {
  isSubmitting: PropTypes.bool,
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  newProfile: PropTypes.bool,
}
